import { removeAddress } from '@api/address';
import PopupComponent from '@components/popup';
import { TAddress } from '@components/types';
import { getAddress, requestLogin } from '@core/utils';
import { addressState } from '@recoil/atoms';
import { Pencil, Trash2 } from 'lucide-react';
import router from 'next/router';
import React, { useState } from 'react';
import { useRecoilState } from 'recoil';

type Props = {
  address: TAddress,
  isChecked: boolean,
  open: Function,
  selectAddress: Function,
  removeCallback: Function,
};


export const AddressCard: React.FC<Props> = ({ address, isChecked, open, selectAddress, removeCallback }) => {
  const [showModel, setShowModel] = useState(false);
  const [selectedAddress, setSelectedAddress] = useRecoilState(addressState);

  const handleRemoveAddress = async () => {
    setShowModel(true);
    if (selectedAddress?.id === address?.id) {
      setSelectedAddress(null);
    }

    if (address?.id !== undefined) {
      const result = removeAddress(address.id);
      result.then((address: TAddress) => { removeCallback(address) }).catch((e) => {
        if (e.response?.status === 401) {
          requestLogin(router.asPath);
        }
      })
    }
  }

  const onRemoveAddress = () => {
    setShowModel(true);
  }

  return (
    <div className="bg-neutral-50 border border-solid border-neutral-300 flex flex-col gap-2 rounded-lg font-manrope p-4">
      <div className="flex flex-col gap-4 items-start">
        <div className="flex flex-row items-center gap-2">
          <div className="radio">
            <label>
              <input onClick={() => selectAddress(address)} type="radio" value={address.id} checked={isChecked} className='cursor-pointer' />
            </label>
          </div>
          <h2 className="text-neutral-700 font-bold text-base capitalize">{address.type && address.type.length > 0 ? address.type : "Home"}</h2>
        </div>
        <div className="flex flex-col gap-2">
          <p className="text-neutral-500 font-medium text-base">{getAddress(address)}</p>
          <div className="flex items-center gap-4">
            <button className="bg-brand-500 hover:opacity-80 focus:opacity-80 py-1 md:px-6 px-2 text-base text-center text-neutral-50 font-medium whitespace-nowrap select-none rounded flex items-center gap-2 cursor-pointer" onClick={() => { open() }}><Pencil className="text-neutral-50 text-lg" /> EDIT</button>
            <button className="bg-neutral-50 hover:opacity-80 focus:opacity-80 py-1 md:px-6 px-2 text-base text-center text-brand-500 font-medium whitespace-nowrap select-none rounded border border-solid cursor-pointer border-brand-500 flex items-center gap-2" onClick={onRemoveAddress}><Trash2 className="text-brand-500" /> DELETE</button>
          </div>
        </div>
      </div>
      <PopupComponent
        setShowModal={setShowModel}
        showModal={showModel}
        title="Are you sure you want to remove this address?"
        btnName="YES, REMOVE address"
        ActionFun={handleRemoveAddress}
        closeBtnName="CANCEL" />
    </div>

  )
}

